import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AutosuggestSearch from '@components/common/autosuggest_search/main';
import Checkbox from '@components/common/checkbox/main';
import RadioButton from '@components/common/radio_button/main';
import { SearchFilterOperator } from '@components/show_page/sections/section_search/SearchTypes';


import _ from 'underscore';

const TagsFilter = ({
  searchableThings,
  searchFilterOperators,
  tags: filteredTags,
  updateFilters,
  updateSearchFilterOperator
}) => {
  const [allTags, setAllTags] = useState([]);
  const [visibleTags, setVisibleTags] = useState([]);

  useEffect(() => {
    if (searchableThings.tags !== undefined) {
      setAllTags(searchableThings.tags);
      const initialVisibleTags = searchableThings.tags.slice(0, 10);
      filteredTags.forEach((selectedTag) => {
        const inFirstTen = initialVisibleTags.map((visibleTag) => visibleTag.name).includes(selectedTag);
        if (!inFirstTen) {
          // add tags that are not included in the initial 10 tags
          // (these are tags that are selected - in filters - and have been added by searching)
          initialVisibleTags.push(
            searchableThings.tags.find((tagObject) => tagObject.name === selectedTag)
          );
        }
      });
      setVisibleTags(initialVisibleTags);
    }
  }, [searchableThings]);

  const updateTags = (suggestion) => {
    const visibleTagsUpdated = [...visibleTags];

    updateFilters(suggestion.name);
    visibleTagsUpdated.push(suggestion);
    setVisibleTags(visibleTagsUpdated);
  };

  if (allTags.length <= 0) { return null; }
  return (
    <div className="filter-section tags">
      <div className="flex-row title">
        <p>{bfTranslate('Top Tags')}</p>
        <div className="radio-button-container">
          <RadioButton
            checkedButton={searchFilterOperators.tags === SearchFilterOperator.AND ? "All" : "Any"}
            labelCopy={bfTranslate("Any selected")}
            name="search-operator-or"
            onChangeFunction={() => updateSearchFilterOperator('tags', SearchFilterOperator.OR)}
            valueCopy="Any"
          />
          <RadioButton
            checkedButton={searchFilterOperators.tags === SearchFilterOperator.AND ? "All" : "Any"}
            labelCopy={bfTranslate("All selected")}
            name="search-operator-or"
            onChangeFunction={() => updateSearchFilterOperator('tags', SearchFilterOperator.AND)}
            valueCopy="All"
          />
        </div>
      </div>
      <div className="tag-columns">
        {visibleTags.map((tag) => {
          const name = tag.name;
          const count = tag.count;
          return (
            <div className="tag-item" key={name}>
              <Checkbox
                size="sm"
                checked={filteredTags.indexOf(name.replace('"', '\\"')) > -1}
                toggle={() => updateFilters(name)}
                label={name}
              />
              <div className="tag-count">{count}</div>
            </div>
          );
        })}
      </div>
      { _.difference(allTags, visibleTags).length === 0 ? '' : (
        <AutosuggestSearch
          id="tag-autosuggest"
          allValues={allTags}
          visibleValues={visibleTags}
          onSelect={updateTags}
        />
      )}
    </div>
  );
};

TagsFilter.propTypes = {
  searchableThings: PropTypes.shape({}).isRequired,
  searchFilterOperators: PropTypes.shape({
    custom_fields: PropTypes.shape({ all: PropTypes.oneOf(Object.values(SearchFilterOperator)) }),
    tags: PropTypes.oneOf(Object.values(SearchFilterOperator)).isRequired,
  }).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  updateFilters: PropTypes.func.isRequired,
  updateSearchFilterOperator: PropTypes.func.isRequired,
};

TagsFilter.defaultProps = {
  tags: [],
};

export default TagsFilter;
